const apiUrl = process.env.REACT_APP_API_URL;

export const PostProjecteDuplicar = async (idOrigen: string, idAulaDestino: string, idUsuari: string) => {
    try {
        const response = await fetch(
            `${apiUrl}:8061/projectes/${idOrigen}/duplicar?aula=${idAulaDestino}&usuari=${idUsuari}`,
            { method: 'POST' }
        );
        if (response.ok || response.status === 201) {
            return true;
        }
        return false;
    } catch (error) {
        console.log('Error duplicant el projecte:', error);
        return false;
    }
};
